import React, { ChangeEvent } from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import styles from './RaiseEscalationForm.module.less';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

type RaiseEscalationFormProps = {
  onCategoryChange: (category: string) => void;
  onDescriptionChange: (description: string) => void;
  initCategoryName: string;
  initDescription: string;
};

const RaiseEscalationForm = (props: RaiseEscalationFormProps) => {
  const { t } = useTranslation();
  const { onCategoryChange, onDescriptionChange, initDescription, initCategoryName } = props;

  const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { target: text } = event;
    onDescriptionChange(text.value);
  };

  const categories = ['notPickedUp', 'notDelivered', 'captainDidntPay', 'requestedRefundForLate', 'Other'];
  const selectOptions = categories.map(option => {
    const categoryName = t(`modal.raiseEscalation.${option}`);
    return (
      <Select.Option
        value={categoryName}
        key={`${option}`}
        className={styles.option}
        data-testid={`escalationCategoryItem`}
      >
        {categoryName}
      </Select.Option>
    );
  });

  return (
    <div>
      <Form layout="vertical" hideRequiredMark data-testid="RaiseEscalationForm" className={styles.form}>
        <div>
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item>
                <Typography.Text>{t('modal.raiseEscalation.provideDetails')}</Typography.Text>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item label={`${t('modal.raiseEscalation.selectCategoryTitle')} *`}>
                <Select
                  showSearch
                  placeholder={t('modal.raiseEscalation.selectCategoryPlaceholder')}
                  optionFilterProp="children"
                  filterOption={true}
                  onChange={onCategoryChange}
                  defaultValue={initCategoryName}
                  data-testid="selectEscalationCategory"
                >
                  {selectOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item label={`${t('modal.raiseEscalation.descriptionTitle')} *`}>
                <TextArea
                  placeholder={t('modal.raiseEscalation.descriptionPlaceholder')}
                  autoSize={{ minRows: 4, maxRows: 4 }}
                  onChange={handleTextChange}
                  data-testid="escalationDescription"
                  defaultValue={initDescription}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default RaiseEscalationForm;
